import React, { FunctionComponent } from 'react';
import '../../../styles/ai-assistant.styles.scss';
import { DATA_QA } from '../../../helpers/data-qa';

export type ButtonProps = {
	text: string;
	title?: string;
	maxWidth?: string;
	onClickAction: (event: React.MouseEvent) => void;
	disabled: boolean;
};

export const GenerateContentButton: FunctionComponent<ButtonProps> = ({ text, title, maxWidth, onClickAction, disabled }) => {
	return (
		<div data-qa={DATA_QA.AI_TOOLS_PANEL_GENERATE_CONTENT_BTN} className='ai-tools-modal-body-content-generate-btn-container'>
			<div
				className={`ai-tools-modal-body-content-generate-btn ${disabled ? 'disabled' : ''}`}
				title={title}
				style={{ maxWidth: maxWidth || 'auto' }}
				onClick={(e) => {
					if (!disabled) {
						onClickAction(e);
					}
				}}
			>
				<span className='ai-assistant-redo-icon' />
				<span className='ai-tools-modal-body-content-generate-text'>{text}</span>
			</div>
		</div>
	);
};

export default GenerateContentButton;
